import { Controller } from "@hotwired/stimulus"
import axios from 'axios';

import { hideModalCarregando, showModalCarregando } from "../../javascript/modal-carregando";
import getFriendlyErrorMessage from "../../javascript/helpers/getFriendlyErrorMessage";

export default class extends Controller {
  connect() {
    console.log('connected');
  }


  async onSubmit(event) {
    event.preventDefault()
    event.stopImmediatePropagation();

    const form = document.getElementById('form-create-atividade-em-lote');
    const formData = new FormData(form);
    const errorContainer = document.getElementById('error-container');
    const listaErros = document.getElementById('lista-erros');

    try {
      showModalCarregando('Criando atividades, aguarde....')
      const { data } = await axios.post(form.action, formData);
      errorContainer.style.display = 'none';
      listaErros.innerHTML = '';

      if(data.atividades.length > 1) {
        window.location.href = '/atividades?notice=Atividades criadas com sucesso';
      } else {
        window.location.href = `/atividades/${data.atividades[0].id}`
      }
    }catch(err) {
      console.log(err);

      let errors = err?.response?.data?.errors;
      if(errors && !Array.isArray(errors)) {
        errors = [errors];
      } else if(!errors) {
        errors = [getFriendlyErrorMessage(err, "Houve um erro ao criar as atividades. Por favor, tente novamente")];
      }

      listaErros.innerHTML = errors.map((error) => `<p>${error}</p>`).join('');
      errorContainer.style.display = 'block';

    } finally {
      hideModalCarregando()
    }
  }
}